import {
    Autocomplete, Box, Button, Stack, TextField, Typography, Divider,
    Chip, FormControl, RadioGroup, Radio, FormControlLabel
} from '@mui/material'
import React, { Component } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { Colors } from '../../../../Styles/Colors'
import { debounce } from '../../../../Components/CommonFunctions/CommonFunctions'
import { DeletePopup } from '../../../../Components/Common Components/CommonComponents';
import {  grey } from '@mui/material/colors';
import VoiceToText from '../../../../Components/Common Components/VoiceToText';
import  MicIcon from '@mui/icons-material/Mic';
export default class DocFinalDiagnosisRight extends Component {
    constructor(props) {
        super(props)
        this.state = {
            finalDiagnosisTxt: "",
            finalDiagnosisOption: [],
            FrequentData: [],
            IcdSearchKey: "",
            ICDdatas: [],
            selecticd: null,
            SearchBy: "icd_code",
            removeData: false,
            DiagnosisData: [],
            isPostClked: false,
            listenPopUp: false,
        }
        this.getICDSearchApi = debounce(this.getICDcode, 500)
        this.getSuggestionApi = debounce(this.getFinalDiagnosisSuggestion, 500)
    }

    componentDidMount() {
        this.GetICDFrequents();
        if (this.props.EditFinalDiagnosisTxt) {
            this.setState({
                finalDiagnosisTxt: this.props.EditFinalDiagnosisTxt,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.EditFinalDiagnosisTxt !== this.props.EditFinalDiagnosisTxt) {
            this.setState({
                finalDiagnosisTxt: this.props.EditFinalDiagnosisTxt,
            });
        }
        if (prevProps?.copyPostData !== this.props?.copyPostData) {
            this.postFinalDiagnosis(this.props.copyPostData)
        }
    }

    getICDcode = (searchKey = '') => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_REGISTRY_ICD_SEARCH + `?${this.state.SearchBy}=${searchKey}`)
                .then(response => {
                    if (response.data.status === 'success') {
                        if (this.state.IcdSearchKey || this.state.selecticd) {
                            this.setState({
                                ICDdatas: response.data ? response.data.data : []
                            })
                        }
                    }
                }).catch(e => {
                    if (e.response?.data?.status === "fail") {
                        this.errorMessage(e.response.data.message)
                    } else {
                        this.errorMessage(e.message)
                    }
                })

        } catch (e) {
            this.errorMessage(e.message)
        }
    }

    GetICDFrequents() {
        try {
            RestAPIService.getAll(Serviceurls.DOC_FINAL_DIAGNOSIS_ICD_GET)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            FrequentData: response.data.data
                        })
                    }
                    else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    ClearData() {
        this.setState({
            IcdSearchKey: "",
            ICDdatas: [],
            selecticd: null,
            SearchBy: "icd_code",
            DiagnosisData: [],
        })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    getFinalDiagnosisSuggestion = (search = '') => {
        try {
            RestAPIService.getAllTwo(Serviceurls.DOC_FINAL_DIAGNOSIS_SUGGESTION + `?search_key=${search}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        if (this.state.finalDiagnosisTxt) {
                            this.setState({
                                finalDiagnosisOption: response.data.data ? response.data.data : []
                            })
                        }
                    }
                    else {
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.errorMessage(error.message)
                })
        }
        catch (e) {
            this.errorMessage(e.message)
        }
    }

    getFinalDiagnosis() {
        try {
            this.setState({ isPostClked: true })
            RestAPIService.getAllTwo(Serviceurls.DOC_FINAL_DIAGNOSIS_GET + `?patient_id=${this.props?.PatientData?.patient_id}&appointment_id=${this.props?.PatientData?.appointment_id}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                            DiagnosisData: response.data.data?.icd_codes ? response.data.data?.icd_codes : [],
                        }, () => {
                            this.postFinalDiagnosis();
                        })
                    }
                    else {
                        this.setState({ isPostClked: false })
                        this.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    this.setState({ isPostClked: false })
                    this.errorMessage(error.message)
                })
        }
        catch (e) {
            this.setState({ isPostClked: false })
            this.errorMessage(e.message)
        }
    }

    postFinalDiagnosis(copyData = {}) {
        try {
            let states = this.state
            const isCopyData = (copyData && Object.keys(copyData)?.length > 0);
            if ((states?.selecticd && Object.keys(states?.selecticd).length > 0) || (states.finalDiagnosisTxt !== "") || isCopyData) {
                let data = isCopyData ? copyData : {
                    comments: this.state.finalDiagnosisTxt ? this.state.finalDiagnosisTxt : "",
                    appointment_id: this.props?.PatientData?.appointment_id,
                    patient_id: this.props?.PatientData?.patient_id,
                    system_name: 'Final Diagnosis',
                    custom_name: this.props.SelectedCompCustomName ? this.props.SelectedCompCustomName : '',
                    icd_codes: states?.selecticd ? [...states.DiagnosisData, { id: null, ...states.selecticd }] : [],
                }
                RestAPIService.create(data, Serviceurls.DOC_FINAL_DIAGNOSIS_GET)
                    .then((response) => {
                        if (response.data.status === "success") {
                            this.setState({ isPostClked: false })
                            this.successMessage(response.data.message)
                            this.ClearData()
                            this.props.CallgetApi('final_diagnosis')
                            if(isCopyData){
                                this.props.closePreviousPopUp()
                            }
                        } else {
                            this.setState({ isPostClked: false })
                            this.errorMessage(response.data.message)
                        }
                    }).catch(error => {
                        this.setState({ isPostClked: false })
                        if (error?.response?.data?.status === "fail") {
                            this.errorMessage(error.response.data.message)
                        } else {
                            this.errorMessage(error.message)
                        }
                    })
            } else {
                this.setState({ isPostClked: false })
                this.errorMessage("Enter Final Diagnosis")
            }
        } catch (error) {
            this.setState({ isPostClked: false })
            this.errorMessage(error.message)
        }
    }
    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    deleteFrequencysugg = () => {
        try {
            this.setState({ removeData: true })
            RestAPIService.delete(`${Serviceurls.DOC_FINAL_DIAGNOSIS_ICD_GET}?icd_code=${this.state.SelectedDeleteChip?.icd_code}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        this.successMessage(response?.data?.message)
                        this.GetICDFrequents()
                        this.setState({ deletePopup: false, SelectedDeleteChip: null, removeData: false })
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        this.setState({ removeData: false })
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.setState({ removeData: false })
                        this.errorMessage(error.message)
                    }
                })
        } catch (error) {
            this.setState({ removeData: false })
            this.errorMessage(error.message)
        }
    }

    popupClose = () => {
        try {
            this.setState({
                deletePopup: false
            })
        } catch (error) {
            this.errorMessage(error.message)
        }
    }
    listenPopUp = () => {
        this.setState({
            listenPopUp: false
        })
    }

    voiceToTextgetter = (textStorage) => {
        if (textStorage != '') {
            this.setState({
                finalDiagnosisTxt: this.state.finalDiagnosisTxt + " " + textStorage,
                listenPopUp: false
            })
        }
    }

    render() {
        let states = this.state;
        const lable = this.props.SelectedCompCustomName ? this.props.SelectedCompCustomName : 'Final Diagnosis';
        return (
            <Box emed_tid="doc_final_diagnosis_right_container">
                <Box height={"61.3vh"} overflow={"auto"} emed_tid="doc_final_diagnosis_right_content">
                    <Typography className='eMed_refdoc_title' emed_tid="doc_final_diagnosis_right_title">{lable}</Typography>
                    <Box emed_tid="doc_final_diagnosis_right_icd_search_box">
                        <Autocomplete
                            emed_tid="doc_final_diagnosis_right_icd_autocomplete"
                            onClose={() => {
                                if (!this.state.selecticd && states.ICDdatas?.length > 0) {
                                    this.setState({ ICDdatas: [] })
                                }
                            }}
                            noOptionsText={states.IcdSearchKey === '' ? 'Please Search...' : 'No Data Found...'}
                            options={states.ICDdatas}
                            getOptionLabel={(options) => options.icd_code + " | " + options.icd_short_desc + " | " + options.icd_desc}
                            onChange={(e, value) => {
                                this.setState({
                                    testRow: value,
                                    selecticd: value
                                })
                            }}
                            value={states.selecticd}
                            size='small'
                            className='eMed_DocNotes_icd_TxtBox'
                            disablePortal
                            id="combobox-demo"
                            renderInput={(params) => <TextField onChange={(event) => {
                                const value = event.target.value
                                if (value) {
                                    this.setState({ IcdSearchKey: value })
                                    this.getICDSearchApi(value)
                                } else {
                                    this.setState({ IcdSearchKey: value, ICDdatas: [] })
                                }
                            }} {...params} emed_tid="doc_final_diagnosis_right_icd_textfield" placeholder={this.state.SearchBy === "icd_code" ? "Enter ICD Code" : "Enter Description"} inputProps={{ ...params.inputProps, emed_tid: "doc_final_diagnosis_right_icd_input" }} />}
                        />
                        <FormControl sx={{ marginLeft: "1vw" }} emed_tid="doc_final_diagnosis_right_search_by_formcontrol">
                            <RadioGroup row
                                emed_tid="doc_final_diagnosis_right_search_by_radiogroup"
                                value={this.state.SearchBy}
                                onChange={(e) => {
                                    this.setState({ SearchBy: e.target.value })
                                }}
                            >
                                <FormControlLabel value="icd_code" control={<Radio size='small' emed_tid='doc_final_diagnosis_right_search_by_code_radio'/>} label="Search by ICD Code" emed_tid="doc_final_diagnosis_right_search_by_code_label" />
                                <FormControlLabel value="desc" control={<Radio size='small' emed_tid='doc_final_diagnosis_right_search_by_desc_radio'/>} label="Search by Description" emed_tid="doc_final_diagnosis_right_search_by_desc_label" />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                    <Divider textAlign="left" sx={{ marginTop: '0.5vw' }} emed_tid="doc_final_diagnosis_right_icd_codes_divider"><Typography sx={{ fontSize: '0.8vw' }} emed_tid="doc_final_diagnosis_right_icd_codes_label">ICD Codes</Typography></Divider>
                    <Box className="eMed_DocNotes_FreqChips_Wrapp" emed_tid="doc_final_diagnosis_right_icd_codes_chips">
                        {
                            this.state.FrequentData.length > 0 ? this.state.FrequentData.map((item, index) => (
                                <Chip
                                    emed_tid={`doc_final_diagnosis_right_icd_code_chip_${index}`}
                                    size='small'
                                    className={`eMed_chip ${this.state.selecticd?.icd_code === item?.icd_code ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                    key={index}
                                    label={item.icd_code}
                                    variant={this.state.selecticd?.icd_code === item?.icd_code ? 'contained' : "outlined"}
                                    onClick={() => { this.setState({ selecticd: item }) }}
                                    onDelete={() => { this.setState({ deletePopup: true, SelectedDeleteChip: item }) }}
                                />
                            )) : null
                        }
                    </Box>
                    <Divider textAlign="left" sx={{ marginTop: '0.5vw' }} emed_tid="doc_final_diagnosis_right_short_desc_divider"><Typography sx={{ fontSize: '0.8vw' }} emed_tid="doc_final_diagnosis_right_short_desc_label">Short Description</Typography></Divider>
                    <Box className="eMed_DocNotes_FreqChips_Wrapp" emed_tid="doc_final_diagnosis_right_short_desc_chips">
                        {
                            this.state.FrequentData.length > 0 ? this.state.FrequentData.map((item, index) => (
                                <Chip
                                    emed_tid={`doc_final_diagnosis_right_short_desc_chip_${index}`}
                                    size='small'
                                    className={`eMed_chip ${this.state.selecticd?.icd_code === item?.icd_code ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                    key={index}
                                    label={item.short_desc}
                                    variant={this.state.selecticd?.icd_code === item?.icd_code ? 'contained' : "outlined"}
                                    onClick={() => { this.setState({ selecticd: item }) }}
                                    onDelete={() => { this.setState({ deletePopup: true, SelectedDeleteChip: item }) }}
                                />
                            )) : null
                        }
                    </Box>
                    <Divider textAlign="left" sx={{ marginTop: '0.5vw' }} emed_tid="doc_final_diagnosis_right_long_desc_divider"><Typography sx={{ fontSize: '0.8vw' }} emed_tid="doc_final_diagnosis_right_long_desc_label">Long Description</Typography></Divider>
                    <Box className="eMed_DocNotes_FreqChips_Wrapp" emed_tid="doc_final_diagnosis_right_long_desc_chips">
                        {
                            this.state.FrequentData.length > 0 ? this.state.FrequentData.map((item, index) => (
                                <Chip
                                    emed_tid={`doc_final_diagnosis_right_long_desc_chip_${index}`}
                                    size='small'
                                    className={`eMed_chip ${this.state.selecticd?.icd_code === item?.icd_code ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                                    key={index}
                                    label={item.desc}
                                    variant={this.state.selecticd?.icd_code === item?.icd_code ? 'contained' : "outlined"}
                                    onClick={() => { this.setState({ selecticd: item }) }}
                                    onDelete={() => { this.setState({ deletePopup: true, SelectedDeleteChip: item }) }}
                                />
                            )) : null
                        }
                    </Box>
                    <Box emed_tid="doc_final_diagnosis_right_notes_box">
                        <Box className='eMed_refdoc_title' sx={{display: "flex", justifyContent :"space-between"}} emed_tid="doc_final_diagnosis_right_notes_header">
                            <Typography emed_tid="doc_final_diagnosis_right_notes_label">{`${lable} notes`}</Typography>
                            <MicIcon sx={{ color: grey[1000], cursor: "pointer", marginRight: "1.1vw" }} onClick={() => { this.setState({ listenPopUp: true }) }} emed_tid="doc_final_diagnosis_right_notes_mic_icon"></MicIcon >
                        </Box>
                        <Autocomplete
                            emed_tid="doc_final_diagnosis_right_notes_autocomplete"
                            size='small'
                            clearIcon
                            freeSolo
                            autoSelect={false}
                            sx={{ margin: '1vw' }}
                            options={this.state.finalDiagnosisOption ? this.state.finalDiagnosisOption : []}
                            getOptionLabel={option => typeof (option) === "string" ? option : option.comments}
                            value={this.state.finalDiagnosisTxt ? this.state.finalDiagnosisTxt : ''}
                            onChange={(e, value) => {
                                this.setState({
                                    finalDiagnosisTxt: value?.comments ? value?.comments : '',
                                })
                            }}
                            renderInput={(params) => <TextField {...params}
                                emed_tid="doc_final_diagnosis_right_notes_textfield"
                                inputProps={{ ...params.inputProps, maxLength: 200, emed_tid: "doc_final_diagnosis_right_notes_input" }}
                                multiline={true}
                                rows={4}
                                onChange={(e) => {
                                    this.setState({ finalDiagnosisTxt: e.target.value || '' }, () => {
                                        if (e.target.value) {
                                            this.getSuggestionApi(e.target.value)
                                        } else {
                                            this.setState({ finalDiagnosisOption: [] })
                                        }
                                    })
                                }}
                                label={`${lable} notes`}
                                placeholder={`${lable} notes (Max 200 Characters)`} />}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center" height={"6vh"} emed_tid="doc_final_diagnosis_right_actions">
                    <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={() => { this.ClearData() }} emed_tid="doc_final_diagnosis_right_clear_btn">{"Clear"}</Button>
                    <Button variant='contained' size="small" id="eMed_Config_btn" disabled={states.isPostClked} onClick={() => { this.getFinalDiagnosis() }} emed_tid="doc_final_diagnosis_right_add_btn">{"Add"}</Button>
                </Stack>
                {this.state.isErrorMsg ?
                    <ToastMsg
                        emed_tid="doc_final_diagnosis_right_error_toast"
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        emed_tid="doc_final_diagnosis_right_success_toast"
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.deletePopup && <DeletePopup
                    emed_tid="doc_final_diagnosis_right_delete_popup"
                    DeletTitle={`Are you sure ? Do you want to remove ${this.state.SelectedDeleteChip?.icd_code} from suggestion ?`}
                    deleteAlertPopupClose={this.popupClose.bind(this)}
                    removeData={this.deleteFrequencysugg.bind(this)}
                    disable={this.state.removeData}
                />}
                {this.state.listenPopUp ?
                    <VoiceToText
                        emed_tid="doc_final_diagnosis_right_voice_to_text"
                        voiceTextConverter={this.voiceToTextgetter.bind(this)}
                        listenPopUp={this.listenPopUp.bind(this)}
                    /> : null
                }
            </Box>
        )
    }
}